import React from 'react'
import { Section } from 'src/components/molecules/CheckoutComponents/Elements'
import Form, { useFormContext } from '@jarvis.oddle/core/components/Form'
import Divider from '@jarvis.oddle/core/components/Divider'
import showNotificationToast from '@jarvis.oddle/core/components/ToastNotification'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import Div from '@jarvis.oddle/core/components/Div'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import {
  InlineNotification,
  notificationStates
} from '@jarvis.oddle/core/components/InlineNotification'
import { fetchCheckoutMetaAction, removeSelectedVoucherAction } from 'src/redux/checkout'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import VoucherTicket from 'src/components/molecules/VoucherTicket'

interface VoucherSectionProps {
  selectedVoucher: {
    code: string
    redeemedDate: number
  }
  storeOrderId: string
}

const VoucherSection = ({
  selectedVoucher,
  storeOrderId
}: VoucherSectionProps): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const dispatch = useAppDispatch()
  const { errors, setFieldError } = useFormContext()

  const handleRemoveVoucher = async () => {
    const resp = await dispatch(removeSelectedVoucherAction())
    if (resp?.payload) {
      showNotificationToast.success(t('Voucher removed successfully'))
      setFieldError('voucher', [])
      await dispatch(fetchCheckoutMetaAction({ storeOrderId }))
    }
  }

  return (
    <React.Fragment>
      <Section>
        {errors.voucher && (
          <Form.FieldError>
            <Div marginBottom={marginSizes.small}>
              {(errors.voucher || []).map(
                (error, idx) =>
                  error && (
                    <Div key={idx} marginTop={marginSizes.small}>
                      <InlineNotification
                        lightTheme
                        state={notificationStates.error}
                        text={error}
                      />
                    </Div>
                  )
              )}
            </Div>
          </Form.FieldError>
        )}
        <VoucherTicket
          removeSelectedVoucherAction={handleRemoveVoucher}
          selectedVoucher={selectedVoucher}
          defaultTitle={t('Redeem Your Vouchers')}
          defaultDescription={t(
            'Select any eligible voucher and enjoy your reward! See all vouchers on your Oddle Eats Account Details page. T&Cs apply.'
          )}
          errors={errors.voucher}
          setVoucherError={setFieldError}
        />
      </Section>
      <Divider />
    </React.Fragment>
  )
}

export default VoucherSection
